export default __webpack_public_path__ + "static/drinks-62b0c969718d7e2933e47f816d3fadfd.png";